import toastr from 'toastr'

const select = (selector) => document.querySelector(selector);
const showMessage = (selector, type) => {
  const element = select(selector)
  if (element) toastr[type](element.innerHTML)
}

showMessage('.flash.info', 'info')
showMessage('.flash.success', 'success')
showMessage('.flash.error', 'error')
showMessage('.flash.alert', 'error')
